module.exports = __webpack_public_path__ + "media/assets/logo_dark_mode-391e841cfb8421b2f5be7cbe48ece0f7.png";